const SET_WISHLIST = 'setWishList';
const ADD_TO_WISHLIST = 'addToWishlist';
const REMOVE_FROM_WISHLIST = 'removeFromWishlist';
const SET_ERROR_MESSAGE = 'setErrorMessage';

export {
  SET_WISHLIST,
  ADD_TO_WISHLIST,
  REMOVE_FROM_WISHLIST,
  SET_ERROR_MESSAGE,
};
